export const saveToken = (token: string) => {
    localStorage.setItem('token', token);
}

export const getToken = () => {
    return localStorage.getItem('token');
}

export const removeToken = () => {
    localStorage.removeItem('token');
}

export const headerAuthorization = () => {
    const token = getToken();
    return { 'Authorization': `Bearer ${token}` }
}
